export default __webpack_public_path__ + "static/media/display.fb5150e9.png";